import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="mx-auto max-w-md text-center">
      <h1 className="font-display text-5xl text-gold-300">404</h1>
      <p className="mt-4 text-cream-300/70">This cellar is empty.</p>
      <Link to="/" className="btn-ghost mt-8 inline-flex">
        Back to the door
      </Link>
    </div>
  );
}
